import { FC } from 'react'
import styled from 'styled-components'
import { BaseButton } from '../buttons'
import CloseIcon from '@tuhi/components/assets/images/closeIcon.svg'

export const headerHeight = '3em'

const Header = styled.header`
    // background-color: ${(p) => p.theme.colors.lighterGrey};
    /* padding-left: 1em; */
    line-height: ${headerHeight};
    font-weight: bold;
    display: flex;
    color: ${(p) => p.theme.colors.darkGrey};
    width: 100%;
    box-sizing: border-box;
`

const HeaderText = styled.span`
    font-weight: bolder;
    font-size: 1.2em;
`

export const CloseButton = styled(BaseButton)`
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${headerHeight};
    aspect-ratio: 1;
    margin-left: auto;
    color: ${(p) => p.theme.colors.darkGrey};

    &:hover {
        background-color: ${(p) => p.theme.colors.primaryRed};
        color: ${(p) => p.theme.colors.white};
    }
`

interface Props {
    title?: string
    onClose?: () => void
}

export const GlobalModalHeader: FC<Props> = ({ title, onClose }) => {
    return (
        <Header>
            <HeaderText>{title}</HeaderText>
            <CloseButton onClick={() => onClose && onClose()}>
                <span
                    style={{
                        width: '32px',
                        height: '32px',
                        display: 'inline-block',
                    }}
                >
                    <CloseIcon />
                </span>
            </CloseButton>
        </Header>
    )
}
